import {del} from '../utils'

export default host => ({
    playlistId,
    musicId,
    type
}) =>
del(`${host}/playlists/${playlistId}/${type}/${musicId}`,null)